module.exports = __webpack_public_path__ + "static/media/BgSignupBusiness.8b647f24.png";